import React, { forwardRef, useImperativeHandle } from "react";
import "./otp-input.css";
import { InsertEvery, Iterations } from "../../utils/genericUtils";
const defaultProps = {
  id: "",
  onKey: () => {},
};

export const OTPInput = forwardRef((props = defaultProps, ref) => {
  function AdvanceInput(keyboardEvent) {
    let current_input = keyboardEvent.target;
    let inputs = document.querySelectorAll(`#${props.id} input`);
    let index = 0;
    let current_index = 0;
    inputs.forEach((input) => {
      if (input === current_input) {
        current_index = index;
      }
      index++;
    });

    let dir = 1;
    if (current_input.value.length === 0) dir = -1;

    let target_input = inputs[current_index + dir];
    if (target_input) target_input.focus();
    if (props.onKey) props.onKey();
  }

  useImperativeHandle(ref, () => ({
    GetValue() {
      let inputs = document.querySelectorAll(`#${props.id} input`);
      let output = "";
      inputs.forEach((input) => {
        output += input.value;
      });
      return InsertEvery(output, "-", 3).toUpperCase();
    },
  }));

  function RenderInputs() {
    let inputs = [];
    let index = 0;
    let inputCount = 6;
    Iterations(inputCount, () => {
      inputs.push(
        <input
          key={index}
          onKeyUp={(e) => {
            AdvanceInput(e);
          }}
          type="text"
          maxLength={1}
        />
      );
      index++;
    });

    return inputs;
  }

  return (
    <section id={props.id} className="otp-input">
      {RenderInputs()}
    </section>
  );
});
